import { AppConfigurationContext } from '@wkda/funnel-components';
import React from 'react';
function useCarleadConfiguration() {
  const ctx = React.useContext(AppConfigurationContext);
  if (!ctx) {
    throw new Error('useCarleadConfiguration must be used within a AppConfigurationContainer');
  }
  return ctx;
}
export { useCarleadConfiguration };